import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FeatherModule } from 'angular-feather';
import { UserService } from '../services/api-services/user.service';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-add-user',
  standalone: true,
  imports: [
    MatFormFieldModule,
    FeatherModule,
    MatCardModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    NgIf,
    MatProgressBarModule
  ],
  templateUrl: './admin-add-user.component.html',
  styleUrl: './admin-add-user.component.scss'
})
export class AdminAddUserComponent implements OnInit {

  checked = true;
  hide = true;

  initialEmail = '';
  initialUsername = '';
  errorMessage: string | null = null;
  successMessage: string | null = null;

  profileForm: FormGroup = new FormGroup({});
  showUpdateSuccess = false;
  isAdmin = true;


  contentLoading = false;

  constructor(private fb: FormBuilder, private apiService: UserService, private router: Router,
     private dialog: MatDialog) {}

  ngOnInit(): void {
    this.contentLoading = false;
    this.profileForm = this.fb.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      repeatEmail: ['', [Validators.required, Validators.email]]
    }, { validators: emailMatchValidator });
    this.refreshView();
  }

  refreshView() {
    this.apiService.isUserAdmin().subscribe({
      next: response => {
        this.isAdmin = response;
        if (response === false) {
          this.router.navigate(['main']);
        }
      },
      error: error => {
        if (!environment.production) {
          console.log(error);
        }
        this.router.navigate(['main']);
      }
    })
  }

  onSubmit() {
    if (this.profileForm.invalid) {
      this.errorMessage = 'Please fill in all required fields correctly.';
      return;
    }

    const { username, email } = this.profileForm.value;

    if (!this.isUsernameValid(username)) {
      this.errorMessage = 'Username should not contain special characters.';
    } else {
      this.contentLoading = true;

      this.apiService.createNewUser(username, email).subscribe({
        next: response => {
          if (!environment.production) {
            console.log(response);
          }
        },
        error: (error) => {
          if (error.error?.error === 'Username already exists.') {
            this.errorMessage = 'The username already exists. Please choose a different username.';
          } else if (error.error?.error === 'Email already exists.') {
            this.errorMessage = 'The email address already exists. Please use a different email.';
          } else {
            this.errorMessage = 'An unexpected error occurred. Please try again later.';
          }
          this.successMessage = null;
          this.contentLoading = false;
        },
        complete: () => {
          this.successMessage = 'User added successfully. An email has been sent to the user.';
          this.errorMessage = null;
          this.profileForm.reset();
          this.contentLoading = false;
        }
      });
    }


  }

  private isUsernameValid(username: string): boolean {
    const specialCharsRegex = /[!@#$%?,";'^&*()]/;
    return !specialCharsRegex.test(username);
  }

  openErrorDialog(errorMessage: string) {
    this.dialog.open(DialogComponent, {
      width: '500px',
      data: {
        dialogTitle: 'Error',
        content: errorMessage,
        newButton: false,
        createFile: false
      }
    });
  }

}

export function emailMatchValidator(control: AbstractControl): ValidationErrors | null {
  const email = control.get('email')?.value;
  const repeatEmail = control.get('repeatEmail')?.value;

  if (email && repeatEmail && email !== repeatEmail) {
    return { emailMismatch: true };
  }

  return null;
}
